import styled from "rn-css/.";
import { useEffect, useState } from "react";
import closeIcon from "../../assets/TopNavBarIcon/icon_nav_close.svg";
import { ScrollView, TouchableOpacity } from "react-native";
import Image from "../Image/Image";
import ENVIRONMENT from "../../config/ENVIRONMENT";
import { DEFAULT_ENV } from "../../config/ENV_CONFIG";
import { AsyncStorageKeys } from "../../Types";
import { getMaster, globalAny } from "../../utils/Utils";
import moment from "moment";

interface Props {
	playerVariant?: any;
	bufferedInfo?: any;
	manifestUrl?: any;
	alpha?: any;
	videoFile?: string;
	audioFile?: string;
	videoStat?: any;
	playbackErrorCode?: any;
	onPress?: () => void;
	isMqtt?: boolean;
}

const StyledContainer = styled.View<any>`
	padding: 1rem 1rem;
	background-color: rgba(0, 0, 0, ${(props) => (props.isMqtt ? "0.1" : "0.7")});
	height: ${(props) => (props.isMqtt ? "auto" : "100%")};
	width: ${(props) => (props.isMqtt ? "auto" : "100%")};
	position: absolute;
	top: 0;
	right: 0;
	z-index: 999;
`;
const StyledInfoContainer = styled.View`
	background-color: transparent;
	gap: 10px;
	width: 100%;
`;
const StyledStreamContainer = styled.View`
	width: 100%;
	display: flex;
	flex-direction: row;
	margin-top: 2rem;
`;
const StyledMqttContainer = styled.View`
	background-color: transparent;
	gap: 10px;
	width: 100%;
`;

const StyledMqttText = styled.Text`
	color: red;
	font-size: 16px;
	font-weight: 300;
	display: flex;
	flex-direction: column;
`;

const StyledNerdStatsContainer = styled.View`
	flex-direction: column;
	width: 50%;
	gap: 30px;
`;
const StyledError = styled.View`
	margin-top: 30px;
`;
const StyledText = styled.Text`
	color: white;
	font-size: 16px;
	font-weight: 300;
	display: flex;
	flex-direction: column;
`;
const StyledStreamText = styled.Text`
	color: white;
	font-size: 16px;
	font-weight: 300;
	display: flex;
	flex-direction: column;
	@media (max-height: 500px) {
		margin-top: -10px;
	}
`;

const StyledTitle = styled.Text`
	font-size: 19px;
	font-weight: 600;
`;

const StyledButton = styled.View`
	top: 30;
	right: 30;
	display: flex;
	flex-direction: row-reverse;
	z-index: 999999;
`;

const Nerds = (props: Props) => {
	const resolution = `${props?.videoStat?.width}x${props?.videoStat?.height}`;
	const audioBandwidth = props.playerVariant?.audioBandwidth / 1000;
	const audioCodec = `${props.playerVariant?.audioCodec}`;
	const videoCodec = props.playerVariant?.videoCodec;
	const channels = props.playerVariant?.channelsCount;
	const language = props.playerVariant?.language;
	const playingBitrate = Math.round(props.playerVariant?.videoBandwidth / 1000000);
	const estimatedBandwidth = Math.round(props.playerVariant?.bandwidth / 1000000);
	const [buffered] = props.bufferedInfo?.total ?? [];
	const bufferedStart = buffered?.start;
	const bufferedEnd = buffered?.end;
	const bufferedTotal = Math.round(bufferedEnd - bufferedStart);
	const [dateTime, setDateTime] = useState(new Date());
	const [errorMessage, setErrorMessage] = useState("");
	const [FPS, setFPS] = useState(0);
	const currentTime = dateTime.toLocaleString("en-US", {
		year: "numeric",
		month: "long",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: true,
	});
	const subtitle = JSON.parse(localStorage.getItem(AsyncStorageKeys.subtitleOnAndOff) ?? "[]");
	const isSubtitleOn = subtitle.data ? "ON" : "OFF";
	const domain = (url: any) => {
		if (!url) return;

		const http = url.split("/");
		const splitUrl = url.split("/");
		return http[0] + "//" + splitUrl[2];
	};

	const videoStat = {
		title: "Video",
		data: [
			{
				title: "Video File:",
				value: props?.videoFile,
			},
			{
				title: "Codec:",
				value: videoCodec,
			},
			{
				title: "Playing Bitrate:",
				value: `${playingBitrate} Mbps`,
			},
			{
				title: "Avg Video Render Rate:",
				value: "1ms",
			},
			{
				title: "Resolution:",
				value: resolution,
			},
			{
				title: "Domain:",
				value: domain(props.manifestUrl),
			},
			{
				title: "Tunneled Buffer Processed:",
				value: domain(props.manifestUrl),
			},
			{
				title: "Color Depth Bitrate:",
				value: screen.colorDepth,
			},
			{
				title: "FPS:",
				value: FPS,
			},
		],
	};

	const auidioStat = {
		title: "Audio",
		data: [
			{
				title: "Audio File:",
				value: props.audioFile,
			},
			{
				title: "Codec:",
				value: audioCodec,
			},
			{
				title: "Bitrate:",
				value: `${audioBandwidth} Kbps`,
			},
			{
				title: "Avg Audio Render Rate:",
				value: "2ms",
			},
			{
				title: "Language:",
				value: language,
			},
			{
				title: "Channel:",
				value: channels,
			},
		],
	};

	const debug = {
		title: "Debug",
		data: [
			{
				title: "Audio Underrun Count:",
				value: "0",
			},
			{
				title: "Audio Performance Issue Counter:",
				value: "0",
			},
			{
				title: "Dropped Buffers:",
				value: "0",
			},
			{
				title: "Blocked Bitrates:",
				value: "none",
			},
			{
				title: "Adv Blocked Bitrates:",
				value: "none",
			},
			{
				title: "Recovery In:",
				value: "N/A",
			},
		],
	};

	const streamHealth = {
		title: "Stream Health",
		data: [
			{
				title: "Total Time Buffering:",
				value: "0s",
			},
			{
				title: "Available Buffer Duration:",
				value: `${bufferedTotal}s`,
			},
			{
				title: "Playing Bitrate:",
				value: `${playingBitrate} Mbps`,
			},
			{
				title: "Estimated Bandwidth:",
				value: `${estimatedBandwidth} Mbps`,
			},
			{
				title: "Average Bitrate:",
				value: `${estimatedBandwidth} Mbps`,
			},
			{
				title: "Speed Test Bitrate:",
				value: "N/A",
			},
		],
	};

	const errorPrompt = {
		title: "",
		data: [
			{
				title: `Error ${props.playbackErrorCode}:`,
				value: errorMessage,
			},
		],
	};
	const renderStreamContent = (content: any) => {
		return (
			<StyledStreamText>
				<StyledTitle>{content.title}</StyledTitle>
				{content.data.map((item: any) => {
					return (
						<span key={item.title}>
							<b>{item.title}</b> {item.value}
						</span>
					);
				})}
			</StyledStreamText>
		);
	};

	useEffect(() => {
		const interval = setInterval(() => {
			setDateTime(new Date());
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (props.playbackErrorCode === 0) return;

		switch (props.playbackErrorCode) {
			case 6007:
				setErrorMessage("LICENSE REQUEST FAILED");
				break;
			case 1003:
				setErrorMessage("CONNECTION TIMEOUT");
				break;
			case 1002:
				setErrorMessage("NETWORK DISCONNECTED");
				break;
			case 1:
				setErrorMessage("PLAYBACK ERROR");
				break;
			default:
				setErrorMessage(`Error ${props.playbackErrorCode}`);
				break;
		}
	}, [props.playbackErrorCode]);

	useEffect(() => {
		let frameCount = 0;
		let lastTime = performance.now();

		const calculateFPS = () => {
			const now = performance.now();
			const elapsed = now - lastTime;
			const calculatedFPS = Math.round(frameCount / (elapsed / 1000));
			const roundedFPS = Math.round(calculatedFPS / 10) * 10;

			setFPS(roundedFPS);
			frameCount = 0;
			lastTime = now;
		};

		const handleFrame = () => {
			frameCount++;
			requestAnimationFrame(handleFrame);
		};

		requestAnimationFrame(handleFrame);
		const interval = setInterval(calculateFPS, 1000);

		return () => {
			clearInterval(interval);
		};
	}, []);

	return (
		<StyledContainer isMqtt={props.isMqtt}>
			<StyledButton>
				<TouchableOpacity onPress={props.onPress}>
					<Image source={{ uri: closeIcon }} width={35} height={35} />
				</TouchableOpacity>
			</StyledButton>
			<ScrollView showsHorizontalScrollIndicator={true}>
				{!props.isMqtt && (
					<>
						<StyledInfoContainer>
							<StyledText>
								<StyledTitle>Info</StyledTitle>
								<span>
									<b>Alpha:</b> {props.alpha}
								</span>
								<span>
									<b>Ultra HD Support:</b>
								</span>
								<span>
									<b>Date (UTC):</b> {currentTime}
								</span>
								<span>
									<b>Subtitle:</b> {isSubtitleOn}
								</span>
							</StyledText>
							{DEFAULT_ENV !== ENVIRONMENT.PRODUCTION ? (
								<StyledText>
									<StyledTitle>Media Info:</StyledTitle>
									<span>
										<b>Manifest Url:</b> {props.manifestUrl}
									</span>
								</StyledText>
							) : (
								<></>
							)}
						</StyledInfoContainer>
						<StyledStreamContainer>
							<StyledNerdStatsContainer>
								{renderStreamContent(videoStat)}
								{renderStreamContent(debug)}
							</StyledNerdStatsContainer>
							<StyledNerdStatsContainer>
								{renderStreamContent(auidioStat)}
								{renderStreamContent(streamHealth)}
							</StyledNerdStatsContainer>
						</StyledStreamContainer>
					</>
				)}
				{props.playbackErrorCode ? <StyledError>{renderStreamContent(errorPrompt)}</StyledError> : <></>}

				{DEFAULT_ENV !== ENVIRONMENT.PRODUCTION && props.isMqtt ? (
					<StyledMqttContainer>
						<StyledMqttText>
							<StyledTitle>MQTT Info</StyledTitle>
							<span>
								<b>Date in ms:</b> {moment().valueOf()}
							</span>
							<span>
								<b>PlaySession ID:</b> {globalAny?.mqttPlayContent?.playSessionId}
							</span>
							<span>
								<b>Device ID:</b> {localStorage.getItem(AsyncStorageKeys.deviceId)}
							</span>
							<span>
								<b>Device Name:</b> {localStorage.getItem(AsyncStorageKeys.profileName)}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Leader:</b> {getMaster(globalAny.mqttPlayContent).deviceName}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Player Position:</b> {window.videoElementTest.currentTime}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Target Position:</b> {globalAny.targetPosition}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Position Diff:</b> {globalAny.posDiff}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Player Playback Rate:</b> {window.videoElementTest.playbackRate}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Last Known Leader Position:</b> {globalAny.lastKnownLeaderPosition}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Last Known Latency:</b> {globalAny.lastKnownLatency}
							</span>
							<span>
								{/* @ts-ignore */}
								<b>Time Since Last Known Leader Position (sec):</b> {globalAny.timeSinceLastKnownLeaderPosition}
							</span>
						</StyledMqttText>
					</StyledMqttContainer>
				) : (
					<></>
				)}
			</ScrollView>
		</StyledContainer>
	);
};

export default Nerds;
